import ToolbarMenuItem from 'features/toolbar/ToolbarMenuItem/ToolbarMenuItem';
import { useLeaveBreakoutControl } from './useLeaveBreakoutControl';

const LeaveBreakoutControl = () => {
  const { icon, label, available, handleAction } = useLeaveBreakoutControl();

  if (!available) {
    return null;
  }

  return (
    <ToolbarMenuItem
      data-testid="leave-breakout-control-menu"
      overlay={label}
      ariaLabel={label}
      icon={icon}
      id="leave-breakout"
      onClick={handleAction}
    />
  );
};

export default LeaveBreakoutControl;
